/**
 * Some notification types store legacy copy in the DB; UI language follows i18n via meta fields.
 */
export function getTranslatedNotificationContent(notification, t) {
  const n = notification || {};
  let meta = n.meta;
  if (meta != null && typeof meta === 'string') {
    try {
      meta = JSON.parse(meta);
    } catch {
      meta = {};
    }
  }
  if (!meta || typeof meta !== 'object') meta = {};

  switch (n.type) {
    case 'presence_hourly_confirm': {
      const hour = meta.alertHourIndex != null ? String(meta.alertHourIndex) : '';
      return {
        title: t('notifications.presence_hourly_title'),
        body: t('notifications.presence_hourly_body', { hour })
      };
    }
    case 'presence_escalation': {
      const name =
        [meta.firstName, meta.lastName].filter(Boolean).join(' ').trim() ||
        (meta.employeeName != null ? String(meta.employeeName) : '');
      const hour = meta.alertHourIndex != null ? String(meta.alertHourIndex) : '';
      return {
        title: t('notifications.presence_escalation_title'),
        body: t('notifications.presence_escalation_body', { name, hour })
      };
    }
    case 'presence_zone_change': {
      const name =
        [meta.firstName, meta.lastName].filter(Boolean).join(' ').trim() ||
        (meta.employeeName != null ? String(meta.employeeName) : '');
      const from = meta.fromSite != null && meta.fromSite !== '' ? String(meta.fromSite) : '—';
      const to = meta.toSite != null && meta.toSite !== '' ? String(meta.toSite) : '—';
      return {
        title: t('notifications.presence_zone_change_title'),
        body: t('notifications.presence_zone_change_body', { name, from, to })
      };
    }
    default:
      return { title: n.title || '', body: n.body || '' };
  }
}

/**
 * Hourly presence: link works only inside the same window as `PRESENCE_CONFIRM_TIMEOUT_MINUTES` (and if not confirmed / escalated — server sets presenceHourlyClickable).
 */
export function isPresenceHourlyLinkActive(notification) {
  const n = notification || {};
  if (n.type !== 'presence_hourly_confirm') return true;
  if (n.presenceHourlyClickable === false) return false;
  if (n.presenceHourlyClickable === true) return true;
  let meta = n.meta;
  if (meta != null && typeof meta === 'string') {
    try {
      meta = JSON.parse(meta);
    } catch {
      meta = null;
    }
  }
  if (meta && typeof meta === 'object' && meta.respondByAt) {
    return Date.now() <= new Date(meta.respondByAt).getTime();
  }
  return true;
}

/** Ensures hourly presence opens attendance with deep-link polling (legacy rows used `/pointage` only). */
export function getNotificationNavigatePath(notification) {
  const n = notification || {};
  if (!n.link) return null;
  if (n.type === 'presence_hourly_confirm' && !String(n.link).includes('presenceConfirm=')) {
    const base = String(n.link).split('#')[0];
    if (base === '/pointage' || base.startsWith('/pointage?')) {
      return base.includes('?') ? `${base}&presenceConfirm=1` : `${base}?presenceConfirm=1`;
    }
  }
  return n.link;
}
